// extracted by mini-css-extract-plugin
export default {"title":"SettigsTitle_title__uCeuX"};